import React, { useContext } from "react";
import "./statusPage.css";
import { Container } from "react-bootstrap";
import { StatusContext } from "../StatusView";
import FilterComponent from "../../../components/FilterComponent/Filter";
import TopBar from "../../../components/TopBarComponent/Topbar";
import AlertBox from "../../../components/AlertComponent/AlertBox";
import { Spinner } from "react-bootstrap";
const StatusPage = () => {
  const {
    filterCriteria,
    setFilterCriteria,
    showDropdownList,
    setShowDropdownList,
    employeeData,
    setEmployeeData,
    submitFilter,
    categoryRequired,
    setEmployeeCode,
    logout,
    statusCode,
    employeeCode,
    employeeCodeRequired,
    showAlert,
    setShowAlert,
    alertMessage,
    setAlertMessage,
    statusSpinnerStatus,
  } = useContext(StatusContext);
  return (
    <>
      <div>
      {statusSpinnerStatus && (
                <div className="spinner-overlay-vehicle-report">
                  <Spinner size="xl" className="custom-spinner-vehicle-report" />
                </div>
              )}
        <TopBar />
        <div>
          <Container
            className="outerContainerStatus"
            onClick={() => {
              showDropdownList == true ? setShowDropdownList(false) : null;
            }}
          >
            <div>
              <FilterComponent
                submitFilter={submitFilter}
                filterCriteria={filterCriteria}
                setFilterCriteria={setFilterCriteria}
                showDropdownList={showDropdownList}
                setShowDropdownList={setShowDropdownList}
                employeeData={employeeData}
                setEmployeeData={setEmployeeData}
                categoryRequired={categoryRequired}
                employeeCodeRequired={employeeCodeRequired}
                spinnerStatus={statusSpinnerStatus}
              />
            </div>
          </Container>
          <AlertBox
            show={showAlert}
            setShow={setShowAlert}
            alertMessage={alertMessage}
            handleSubmit={
              statusCode == 401 ? () => logout() : () => setShowAlert(false)
            }
          />
        </div>
      </div>
    </>
  );
};

export default StatusPage;
